
import { LayoutGrid, Mail, Settings } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const AdvertiseOpportunities = () => {
  const opportunities = [
    {
      title: "Homepage Banners",
      description: "Get premium visibility on our most-visited page.",
      icon: <LayoutGrid className="h-10 w-10 text-primary" />
    },
    {
      title: "Email Sponsorships",
      description: "Advertise in our newsletter sent to engaged homeowners.",
      icon: <Mail className="h-10 w-10 text-primary" />
    },
    {
      title: "Custom Campaigns",
      description: "We can tailor an ad package to fit your needs.",
      icon: <Settings className="h-10 w-10 text-primary" />
    }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-primary">Advertising Opportunities</h2>
            <p className="mt-3 text-muted-foreground">
              Choose from our range of options to reach your target audience
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            {opportunities.map((item, index) => (
              <Card key={index} className="border-primary/10 hover:shadow-md transition-shadow">
                <CardHeader className="pb-2">
                  <div className="mb-2">{item.icon}</div>
                  <CardTitle className="text-xl">{item.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base">{item.description}</CardDescription>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
